import { getPosts, getMediaPosts } from "./_get-posts";

jQuery('document').ready(function () {
    var $archives = $('.archive-block');

    if($archives.length > 0) {
        $archives.each(function(index, archive) {
            if(archive.classList.contains('archive-type-news')) {
                const showMoreBtn = archive.querySelector('.show-more-btn');
                const container = archive.querySelector('.news');
                let offset = 12;
                if(showMoreBtn) {
                    showMoreBtn.addEventListener('click', function(e) {
                        e.preventDefault();
                        getPosts(container, showMoreBtn, offset);
                        offset += 6;
                    });
                }
            }
            else {
                const mediaTypesSelect = archive.querySelector('#media-type');
                const categories = archive.querySelectorAll('.media-categories a');
                let selectedType = new URLSearchParams(document.location.search).get('type') || '';
                let selectedCategory = new URLSearchParams(document.location.search).get('category') || '';
                const showMoreBtn = archive.querySelector('.show-more-btn');
                const container = archive.querySelector('.media-wrapper');
                let offset = 12;

                if(mediaTypesSelect) {
                    mediaTypesSelect.addEventListener('change', function(e) {
                        selectedType = e.target.value;
                        window.location.href = window.location.pathname + '?&type=' + selectedType + '&category=' + selectedCategory;
                    });
                }

                if(categories) {
                    categories.forEach(category => {
                        category.addEventListener('click', function(e) {
                            e.preventDefault();
                            if(this.classList.contains('active')) {
                                selectedCategory = '';
                            }
                            else {
                                selectedCategory = this.getAttribute('data-category');
                            }
                            window.location.href = window.location.pathname + '?&type=' + selectedType + '&category=' + selectedCategory;
                       });
                    });
                }

                if(showMoreBtn) {
                    showMoreBtn.addEventListener('click', function(e) {
                        e.preventDefault();
                        getMediaPosts(container, showMoreBtn, offset, selectedType, selectedCategory);
                        offset += 6;
                    });
                }
            }
        });
    }

});